import genererGuid from '@/services/general/genererGuid';
import * as devisConf from '@/configuration/devisConf';
import genererEcheancierAuto from '@/services/devisCommandes/echeanciers/genererEcheancierAuto';

function getEcheancierLigne(ligne, echeancierLignes) {
  const echLigne = echeancierLignes[0];
  echLigne.dateDebut = ligne.dateDebut;
  echLigne.dateFin = ligne.dateFin;
  echLigne.montant = ligne.totalHtAvecLigneRemise;
  return [echLigne];
}

function getEcheancierAndReferenceEcheancier(ligne, echeancierOld) {
  const echeancier = echeancierOld ? echeancierOld : genererEcheancierAuto();
  echeancier.dateDebut = ligne.dateDebut;
  echeancier.dateFin = ligne.dateFin;
  echeancier.quantitePeriodicite = 0;
  echeancier.dateFinPremiereEcheance = ligne.dateDebut;
  if (!echeancier.referenceEcheancier) {
    echeancier.referenceEcheancier = genererGuid();
  }
  echeancier.echeancierLignes = getEcheancierLigne(ligne, echeancier.echeancierLignes);
  ligne.referenceEcheancier = echeancier.referenceEcheancier;
  return echeancier;
}

export default function addReferenceEcheancierToLigneCommande(ligne, devis, echeanciersOld) {
  if (!ligne.lignesCommande) return;
  ligne.lignesCommande.filter(l => l.type !== devisConf.COMMENTAIRE).forEach((ligneEnfant) => {
    ligneEnfant.dateFin = ligneEnfant.dateFin || ligne.dateFin;
    ligneEnfant.dateDebut = ligneEnfant.dateDebut || ligne.dateDebut;
    ligneEnfant.ligneReseau = ligne.ligneReseau;
    const echeancierOld = echeanciersOld.find(e => e.referenceEcheancier === ligneEnfant.referenceEcheancier);
    const echeancier = getEcheancierAndReferenceEcheancier(ligneEnfant, echeancierOld);
    devis.echeanciers.push(echeancier);
  });
}
